import { useIsAdmin } from "@/hooks/useIsAdmin";
import type { ReactNode } from "react";
import { LoadingPanel } from "./LoadingPanel";
import { NotFoundPanel } from "./NotFoundPanel";

export function AdminRoute({ children }: { children: ReactNode }) {
  const { isAdmin, loading } = useIsAdmin();
  if (loading) return <LoadingPanel />;
  if (!isAdmin) return <NotFoundPanel />;
  return <>{children}</>;
}
